export default {
    translations: {
        "Drag 'n' drop some files here, or click to select files": "Drag 'n' drop some files here, or click to select files",
        "Drop the files here ...": "Drop the files here ...",
        "(We only accept .rar, .zip, .cbr and .cbz)": "(We only accept .rar, .zip, .cbr and .cbz)",
        "Maybe the file type is not supported (We only accept .rar, .zip, .cbr and .cbz)": "Maybe the file type is not supported (We only accept .rar, .zip, .cbr and .cbz)"
    }
}